import React, {Component, useState, useEffect, useRef} from "react";

import LoaderView from "../tools/LoaderView";
import didebanImg from '../assets/images/dideban.jpg';
import dideban1 from '../assets/images/dideban1.jpg';
import dideban2 from '../assets/images/dideban2.jpg';
import gallery1 from "../assets/images/gallery1.png";
import gallery2 from "../assets/images/gallery2.png";
import gallery3 from "../assets/images/gallery3.png";
import gallery4 from "../assets/images/gallery4.png";
import gallery5 from "../assets/images/gallery5.png";
import gallery6 from "../assets/images/gallery6.png";
import gallery7 from "../assets/images/gallery7.png";
import gallery8 from "../assets/images/gallery8.png";
import kar from "../assets/images/kar.jpg";
import zendanian from "../assets/images/zendanian.jpg";

import TopNav from "./TopNav";
import sia from "../services/Api";

const Dideban = () => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [charityInfo, setCharityInfo] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [isLoadingCities, setLoadingCities] = useState(true);

    //Load more buttons
    const [isLoading1, setLoading1] = useState(false);
    const [isLoading2, setLoading2] = useState(false);
    const [isLoading3, setLoading3] = useState(false);
    const [isLoading4, setLoading4] = useState(false);

    const selectedStateIndex = useRef();
    const selectedCityIndex = useRef();

    useEffect(() => {
        getStates()
        getCharitiesAmount()
    }, []);

    const getStates = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("state")
            .then((res) => {
                setStates(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    }

    const getCharitiesAmount = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("charity-info")
            .then((res) => {
                setCharityInfo(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    }

    const getCities = async () => {
        setCities([])
        setLoadingCities(true)
        await sia
            .getDataFromServer("city?state_id=" + states[selectedStateIndex.current].id)
            .then((res) => {
                setCities(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoadingCities(false)
    }

    return (
        <>
            {isLoading ? <LoaderView/> : <div>
                <header>
                    <div className="pagewrapper" id="header-big">
                        <div className="container">
                            <TopNav/>
                        </div>
                        <div className="header-poster poster2">
                            <div className="container">
                                <div className="dideban box-sizing radius10">
                                    <img src={didebanImg} alt="" className="thumb radius10" width height/>
                                    <div className="left-col">
                                        <h2 className="title box-sizing">دیدبان خیرین نکویاد</h2>
                                        <p className="text box-sizing">
                                            ایجاد کمکهای مومنانه و دلگرمی ایتام و نیازمندان از توفیقات این سامانه می
                                            باشد
                                            امید است در پرتو الطاف الهی بتوانیم بخشی از نیاز این قشر از جامعه عزیزمان را
                                            تحت
                                            پوشش قرار دهیم
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="clear"/>
                <div className="pagewrapper" id="statistics">
                    <div className="container col-5">
                        <div className="right-col">
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[0]['amount'] ? charityInfo[0]['amount'] : null}</span>
                                {charityInfo[0]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[1]['amount']}</span>
                                {charityInfo[1]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[2]['amount']}</span>
                                {charityInfo[2]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[3]['amount']}</span>
                                {charityInfo[3]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[4]['amount']}</span>
                                {charityInfo[4]['name']}
                            </div>
                        </div>
                        <div className="pinbar"/>
                        <div className="left-col">
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[5]['amount']}</span>
                                {charityInfo[5]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[6]['amount']}</span>
                                {charityInfo[6]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[7]['amount']}</span>
                                {charityInfo[7]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[8]['amount']}</span>
                                {charityInfo[8]['name']}
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{charityInfo[9]['amount']}</span>
                                {charityInfo[9]['name']}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagewrapper" id="dideban-posts">
                    <div className="container">
                        <div className="dideban-post-item">
                            <img src={dideban1} alt="" className="radius50" width={542} height={394}/>
                            <div className="content">
                                <h2 className="title">کمک به ایتام</h2>
                                <p className="text">
                                    {!isLoading1 ? "ایجاد کمکهای مومنانه و دلگرمی ایتام و نیازمندان از توفیقات این سامانه می باشد امید است" : "ایجاد کمکهای مومنانه و دلگرمی ایتام و نیازمندان از توفیقات این سامانه می باشد امید است در پرتو الطاف الهی بتوانیم بخشی از نیاز این قشر از جامعه عزیزمان را تحت پوشش قرار دهیم"}
                                </p>
                                <a href title className="btn ease radius50" style={{display:"inline-block"}} onClick={() => setLoading1(!isLoading1)}>بیشتر</a>
                            </div>
                        </div>
                        <div className="dideban-post-item">
                            <img src={dideban2} alt="" className="radius50" width={542} height={394}/>
                            <div className="content">
                                <h2 className="title">کمک جهیزیه</h2>
                                <p className="text">
                                    {!isLoading2 ? "ا عنایت به کمک های مالی به دست آمده در تلاش هستیم به همت صنعتگران، کسبه ارجمند و مراکز تحت پوشش" : "با عنایت به کمک های مالی به دست آمده در تلاش هستیم به همت صنعتگران، کسبه ارجمند و مراکز تحت پوشش از محل وجوهات مختص به این موضوع، جهت خرید جهیزیه اقدام نماییم."}
                                </p>
                                <a href title className="btn ease radius50" style={{display:"inline-block"}} onClick={() => setLoading2(!isLoading2)}>بیشتر</a>
                            </div>
                        </div>
                        <div className="dideban-post-item">
                            <img src={zendanian} alt="" className="radius50" width={542} height={394}/>
                            <div className="content">
                                <h2 className="title">خانواده زندانیان</h2>
                                <p className="text">
                                    {!isLoading3 ? "انجام رسالت اجتماعی و پیشگیری از آسیب های اجتماعی و فرهنگی پیشروی خانواده زندانیان غیر عمد یکی دیگر از اهداف نکویاد می باشد" : "انجام رسالت اجتماعی و پیشگیری از آسیب های اجتماعی و فرهنگی پیشروی خانواده زندانیان غیر عمد یکی دیگر از اهداف نکویاد می باشد ما در تلاش هستیم با همراهی متولیان و انجمن های مربوطه، ضمن حفظ آبروی، شأن و جایگاه اجتماعی این عزیزان، نقشی اثر گذار جهت حمایت از این قشر از جامعه عزیزمان برداریم."}
                                </p>
                                <a href title className="btn ease radius50" style={{display:"inline-block"}} onClick={() => setLoading3(!isLoading3)}>بیشتر</a>
                            </div>
                        </div>
                        <div className="dideban-post-item">
                            <img src={kar} alt="" className="radius50" width={542} height={394}/>
                            <div className="content">
                                <h2 className="title">اشتغال زایی</h2>
                                <p className="text">
                                    {!isLoading4 ? "این سامانه در تلاش است به عنوان عضوی از جامعه خیرین نقشی اثرگذار در زمینه فقر زدایی از نیازمندان و محرومین ایفا نماید و همچنین امید دارد" : "این سامانه در تلاش است به عنوان عضوی از جامعه خیرین نقشی اثرگذار در زمینه فقر زدایی از نیازمندان و محرومین ایفا نماید و همچنین امید دارد نسبت به ایجاد اشتغال و ایجاد کارگاه های زود بازده در راستای حمایت از خانواده های کم برخوردار ضمن حفظ شان و آبروی سرپرست خانواده نسبت به افزایش درآمد خانوار اقدام نماید."}
                                </p>
                                <a href title className="btn ease radius50" style={{display:"inline-block"}} onClick={() => setLoading4(!isLoading4)}>بیشتر</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagewrapper" id="galleries">
                    <div className="container">
                        <h2 className="title">گالری تصاویر</h2>
                        <div className="content">
                            <a href title className="gallery-item"><img src={gallery1} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery2} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery3} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery4} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery5} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery6} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery7} alt="" width
                                                                        height/></a>
                            <a href title className="gallery-item"><img src={gallery8} alt="" width
                                                                        height/></a>
                        </div>
                        <a href title="مشاهده همه" className="gallery-more ease">
                            مشاهده همه
                            <span className="ease"><svg version="1.1" width="30px" height="10px" fill="#fff"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 123.725 123.725"
                                                        style={{enableBackground: 'new 0 0 123.725 123.725'}}
                                                        xmlSpace="preserve"> <g> <path
                                d="M2.325,67.002l38.6,30c3.9,3.101,9.7,0.3,9.7-4.7V81.902c0-3.3,2.6-5.9,5.899-5.9h61.5c3.301,0,5.7-2.8,5.7-6.1v-16.1 c0-3.3-2.399-5.8-5.7-5.8h-61.5c-3.3,0-5.899-2.9-5.899-6.2v-10.3c0-5-5.8-7.9-9.8-4.8l-38.5,30.8 C-0.775,59.902-0.775,64.603,2.325,67.002z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></span>
                        </a>
                    </div>
                </div>
                <div className="pagewrapper" id="dideban-donate">
                    <div className="container">
                        <h2 className="main-title">پرداخت و کمک</h2>
                        <p style={{marginTop: '20px', marginBottom: '25px', fontSize: '18px'}}>
                    
                
                خیر ارجمند از حسن توجه جنابعالی به سامانه و مرکز خیریه نکویاد کمال تشکر و قدردانی را داریم. تقاضا می گردد پس از ادای نذر و یا پرداخت هزینه حتما ما را مطلع فرمایید . از همراهی شما بی نهایت سپاسگزاریم.
                <br></br>
05138558474
<br></br>
09150974945


                        </p>
                        <form action="https://nekooyad.com/proc/pay/mohesenin" id="dideban-donate-form" method="post">
                            <input type="text" name="name" placeholder="نام و نام خانوادگی ( غیرضروری )"
                                   className="input box-sizing radius10"/>
                            <select name="type" className="input select radius10 box-sizing ease">
                                <option value={-1}>نحوه کمک</option>
                                <option value="ارسالی">ارسالی</option>
                                <option value="واریزی">واریزی</option>
                            </select>
                            <select name="state" onChange={(e) => {
                                selectedStateIndex.current = e.target.value
                                getCities()
                            }} className="input select radius10 box-sizing ease">
                                <option value={-1}>استان</option>
                                {states.map((item, index) => <option value={index}>{item.name}</option>)}
                            </select>
                            <select name="city" onChange={(e) => {
                                selectedCityIndex.current = e.target.value
                            }} className="input select radius10 box-sizing ease">
                                <option value={-1}>شهر</option>
                                {!isLoadingCities && cities.map((item, index) => <option
                                    value={index}>{item.name}</option>)}
                            </select>
                            <select name="kind" className="input select radius10 box-sizing ease">
                                <option value={-1}>نوع کمک</option>
                                {!isLoading && charityInfo.map((item, index) => <option
                                    value={index}>{item['name']}</option>)}
                            </select>
                            <input type="text" name="amount" placeholder="میزان هزینه (تومان)"
                                   className="input box-sizing radius10"/>
                            <textarea name="description" placeholder="توضیحات"
                                      className="input message box-sizing radius10"/>
                            <input type="submit" className="submit ease box-sizing radius10" value="ارسال"/>
                        </form>
                    </div>
                </div>
                <div className="clear"/>
            </div>
            }
        </>
    );
}

export default Dideban;
